export class FeeProviderPricingApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getFeeProviders({ feeProviderCategoryId }) {
    return this.#http.get('/api/fee-providers', { params: { feeProviderCategoryId } });
  }

  async createFeeProvider(body) {
    return this.#http.post('/api/fee-providers', body);
  }

  async updateFeeProvider({ feeProviderId, ...body }) {
    return this.#http.put(`/api/fee-providers/${feeProviderId}`, body);
  }

  async deleteFeeProvider({ feeProviderId }) {
    return this.#http.delete(`/api/fee-providers/${feeProviderId}`);
  }
}
